import React from "react"
import { RadioBox } from "./helper";
import { Translate } from "react-localize-redux";

const ans = ['L', 'R', 'L', 'B', 'R', 'T', 'T', 'B', 'R', 'T', 'B', 'R', 'T', 'L']
export class FarLeftVision extends RadioBox {
    constructor(props) {
        super(props, props.setState)
    }
	render() {
		return (
			<Translate key={this.props.template.id}>
				{({ translate }) => 
					<tr>
						<td colSpan="2">
							4. {this.props.template.name}
						</td>
                        {
                            ans.map((x, index) => 
                                <td
                                    key={index}
                                    className={`
                                        ${index+1 <= 5 ? "highlight": ''}
                                        ${index+1 === 10 ? "border-left": ''}
                                    `.trim()}
                                >
                                    <label className={this.state.value === `${index+1}` ? 'active': ''}>
                                        <input
                                            name="far-left-eyes"
                                            type="radio"
                                            value={`${index+1}`}
                                            onChange={(e) => this.onChangeHandler(e)}
                                            onClick={e => this.onClickHandler(e)}
									        checked={this.state.value === `${index+1}`}
                                        />
                                        {x}
                                    </label>
                                </td>
                            )
                        }
                        <td></td>
					</tr>
				}
			</Translate>
		)
	}
}